export default class HelperAjax {
	/**
	 * @param requestMethod - string. POST/GET.
	 * @param url - string. ajax URL.
	 * @param requestBody - string. request data.
	 * @param headers - oject. Headers.
	 * @return JSON data as string.
	 *
	 */

	static fetch(requestMethod, url, requestBody, headers = {}) {

		const isCypressTestRun = window.cypressTest;

		/**
		 * Check if is IE
		 */
		let ua = window.navigator.userAgent;
		let isIE = (ua.indexOf('MSIE ') > 0) || (ua.indexOf('Edge/') > 0) || (ua.indexOf('Trident/') > 0);

		if (isIE || isCypressTestRun === true) {

			/**
			 * IE only
			 */
			return new Promise(function(resolve, reject) {
				let xhr = new XMLHttpRequest();
				xhr.onreadystatechange = function() {
					if (xhr.readyState !== 4) {
						return;
					}
					if ((xhr.status >= 200) && (xhr.status < 300)) {
						resolve({
							respCode: xhr.status,
							respBody: xhr.response
						});
					} else {
						reject({
							respCode: xhr.status,
							respBody: ''
						});
					}
				};
				xhr.onerror = function() {
					reject({
						respCode: xhr.status,
						respBody: ''
					});
				};
				xhr.open(requestMethod, url);
				xhr.withCredentials = true;
				if (headers) {
					Object.keys(headers).forEach(function(key) {
						xhr.setRequestHeader(key, headers[key]);
					});
				}
				xhr.send(requestBody);
			});

		} else {
			/**
			 * Any other browser, not IE.
			 */
			let request = {
				method: requestMethod,
				url: url,
				body: requestBody,
				cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
				credentials: 'include', // include, same-origin, *omit
				headers: new Headers(headers)
			};

			let status = null;
			return fetch(url, request)
				.then(response => {
					status = response.status;
					return response.text();
				})
				.then(data => {
					return {
						respCode: status,
						respBody: data
					};
				});
		}
	}
}